import { Typography } from '@euler/app/components/typography';
import { Center } from '@euler/components/Center';
import { Icon, IconType } from '@euler/components/Icomoon';
import { EulerTouchableOpacityProps } from '@euler/components/layout';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { FC, ReactElement, ReactNode, memo } from 'react';
import { StyleProp, TextStyle } from 'react-native';
import { useTheme } from 'styled-components';

export const LinkButton: FC<
  {
    text?: string;
    textSize?: number;
    textStyle?: StyleProp<TextStyle>;
    children?: ReactNode;
    icon?: Exclude<ReactElement, string> | IconType;
    iconSize?: number;
    disabled?: boolean;
    border?: boolean;
    borderColor?: string;
  } & EulerTouchableOpacityProps
> = memo(
  ({
    text,
    textSize,
    icon,
    iconSize,
    textStyle,
    disabled,
    children,
    border,
    borderColor,
    ...props
  }) => {
    const theme = useTheme();
    const { rpx } = useResponsiveContext();
    return (
      <Center.Touchable
        flexDirection="row"
        disabled={disabled}
        {...props}
        css={`
          border-width: ${border ? 1 : 0}px;
          border-color: ${borderColor ?? theme.link};
          padding: 0 ${border ? rpx(5) : 0}px;
          border-radius: ${rpx(3)}px;
        `}
      >
        {typeof icon === 'string' ? (
          <Icon
            name={icon as any}
            color={disabled ? '#333' : theme.link}
            size={iconSize ?? rpx(textSize ?? 15)}
          />
        ) : (
          icon
        )}
        {text ? (
          <Typography.Text
            regular
            size={rpx(textSize ?? 15)}
            color={disabled ? '#333' : theme.link}
            opacity={disabled ? 0.25 : 1}
            style={textStyle}
            ml={icon ? rpx(4) : 0}
          >
            {text}
          </Typography.Text>
        ) : null}
        {children}
      </Center.Touchable>
    );
  },
);
